import React from 'react';

// Pixel-style icons that mimic the classic Windows Server 2016 ADUC icons.
// These are inline SVGs for a pixel-perfect retro look.

export const FolderIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3h5l2 2h7v9H1z" fill="#FFD27A" stroke="#A67C2E" strokeWidth="0.5" />
    <path d="M1 5h14v9H1z" fill="#FFC859" stroke="#A67C2E" strokeWidth="0.5" />
  </svg>
);

// The classic ADUC OU icon - yellow folder with a book on it
export const OUIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3h5l2 2h7v9H1z" fill="#FFD27A" stroke="#8B6914" strokeWidth="0.5" />
    <path d="M1 5h14v9H1z" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
    <rect x="4" y="8" width="8" height="5" fill="#FFFFFF" stroke="#555" strokeWidth="0.5" />
    <line x1="8" y1="8" x2="8" y2="13" stroke="#555" strokeWidth="0.5" />
    <line x1="5" y1="9.5" x2="7" y2="9.5" stroke="#888" strokeWidth="0.4" />
    <line x1="5" y1="11" x2="7" y2="11" stroke="#888" strokeWidth="0.4" />
    <line x1="9" y1="9.5" x2="11" y2="9.5" stroke="#888" strokeWidth="0.4" />
    <line x1="9" y1="11" x2="11" y2="11" stroke="#888" strokeWidth="0.4" />
  </svg>
);

// Container (different from OU - no book icon, simpler)
export const ContainerIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3h5l2 2h7v9H1z" fill="#FFD27A" stroke="#8B6914" strokeWidth="0.5" />
    <path d="M1 5h14v9H1z" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
  </svg>
);

// Domain icon - classic three computers connected
export const DomainIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" fill="#E3F0FF" stroke="#4A7AB8" strokeWidth="0.5" />
    <rect x="5" y="2" width="6" height="4" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.5" />
    <rect x="1" y="10" width="5" height="3" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.5" />
    <rect x="10" y="10" width="5" height="3" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.5" />
    <line x1="8" y1="6" x2="3" y2="10" stroke="#2B579A" strokeWidth="0.4" />
    <line x1="8" y1="6" x2="13" y2="10" stroke="#2B579A" strokeWidth="0.4" />
  </svg>
);

// User icon - classic head & shoulders
export const UserIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="5" r="2.5" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.5" />
    <path d="M3 14c0-3 2.5-5 5-5s5 2 5 5z" fill="#5A7FB8" stroke="#1F3A6B" strokeWidth="0.5" />
    <rect x="7" y="8" width="2" height="2" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.3" />
  </svg>
);

// Group icon - two heads
export const GroupIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="2" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.4" />
    <circle cx="11" cy="5" r="2" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.4" />
    <path d="M1 13c0-2 2-3.5 4-3.5s4 1.5 4 3.5z" fill="#D4A76A" stroke="#7A5020" strokeWidth="0.4" />
    <path d="M7 13c0-2 2-3.5 4-3.5s4 1.5 4 3.5z" fill="#D4A76A" stroke="#7A5020" strokeWidth="0.4" />
  </svg>
);

// Computer icon - classic CRT monitor
export const ComputerIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="2" width="14" height="9" fill="#D4D4D4" stroke="#555" strokeWidth="0.5" />
    <rect x="2" y="3" width="12" height="7" fill="#5B9BD5" stroke="#1F4E79" strokeWidth="0.3" />
    <rect x="6" y="11" width="4" height="2" fill="#D4D4D4" stroke="#555" strokeWidth="0.5" />
    <rect x="4" y="13" width="8" height="1" fill="#B0B0B0" stroke="#555" strokeWidth="0.4" />
  </svg>
);

// Saved Queries icon
export const SavedQueriesIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3h5l2 2h7v9H1z" fill="#FFD27A" stroke="#8B6914" strokeWidth="0.5" />
    <path d="M1 5h14v9H1z" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
    <circle cx="10" cy="10" r="2.5" fill="none" stroke="#333" strokeWidth="1" />
    <line x1="12" y1="12" x2="14" y2="14" stroke="#333" strokeWidth="1.2" />
  </svg>
);

// Builtin icon - shield-like
export const BuiltinIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3h5l2 2h7v9H1z" fill="#FFD27A" stroke="#8B6914" strokeWidth="0.5" />
    <path d="M1 5h14v9H1z" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
    <path d="M8 7l-3 1v2c0 2 1.5 3 3 3.5 1.5-.5 3-1.5 3-3.5V8z" fill="#E8E8E8" stroke="#333" strokeWidth="0.5" />
  </svg>
);

// Get icon by object type
export const getIconForType = (type, size = 16) => {
  switch (type) {
    case 'OU':
      return <OUIcon size={size} />;
    case 'CONTAINER':
      return <ContainerIcon size={size} />;
    case 'DOMAIN':
      return <DomainIcon size={size} />;
    case 'USER':
      return <UserIcon size={size} />;
    case 'GROUP':
      return <GroupIcon size={size} />;
    case 'COMPUTER':
      return <ComputerIcon size={size} />;
    case 'SAVED_QUERIES':
      return <SavedQueriesIcon size={size} />;
    case 'BUILTIN':
      return <BuiltinIcon size={size} />;
    case 'ROOT':
      return <RootIcon size={size} />;
    default:
      return <ContainerIcon size={size} />;
  }
};

// ADUC root snap-in icon (two little people with a folder)
export const RootIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="4" width="14" height="10" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
    <circle cx="5" cy="8" r="1.5" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.4" />
    <circle cx="10" cy="8" r="1.5" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.4" />
    <path d="M2 13c0-1.5 1.5-2.5 3-2.5s3 1 3 2.5z" fill="#5A7FB8" stroke="#1F3A6B" strokeWidth="0.4" />
    <path d="M7 13c0-1.5 1.5-2.5 3-2.5s3 1 3 2.5z" fill="#5A7FB8" stroke="#1F3A6B" strokeWidth="0.4" />
  </svg>
);

// Toolbar icons (16x16 classic MMC style)
export const ToolbarIcon = ({ kind, disabled = false }) => {
  const opacity = disabled ? 0.35 : 1;
  const common = { width: 16, height: 16, style: { opacity } };
  switch (kind) {
    case 'back':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <path d="M11 2L5 8l6 6" stroke="#2B579A" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'forward':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <path d="M5 2l6 6-6 6" stroke="#2B579A" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'up':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <path d="M2 9l6-6 6 6" stroke="#2B579A" strokeWidth="2" fill="none" />
          <rect x="5" y="8" width="6" height="6" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
        </svg>
      );
    case 'refresh':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <path d="M13 8a5 5 0 1 1-1.5-3.5L13 3v4H9" stroke="#2B579A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </svg>
      );
    case 'properties':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <rect x="2" y="2" width="12" height="12" fill="#FFFFFF" stroke="#555" strokeWidth="0.6" />
          <line x1="4" y1="5" x2="12" y2="5" stroke="#555" strokeWidth="0.6" />
          <line x1="4" y1="8" x2="12" y2="8" stroke="#555" strokeWidth="0.6" />
          <line x1="4" y1="11" x2="9" y2="11" stroke="#555" strokeWidth="0.6" />
          <rect x="10" y="10" width="4" height="4" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
        </svg>
      );
    case 'find':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <circle cx="7" cy="7" r="4" fill="none" stroke="#333" strokeWidth="1.5" />
          <line x1="10" y1="10" x2="14" y2="14" stroke="#333" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case 'newuser':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <circle cx="6" cy="5" r="2" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.5" />
          <path d="M2 13c0-2 2-3.5 4-3.5s4 1.5 4 3.5" fill="#5A7FB8" stroke="#1F3A6B" strokeWidth="0.5" />
          <circle cx="12" cy="11" r="3" fill="#FFD700" stroke="#8B6914" strokeWidth="0.5" />
          <line x1="12" y1="9" x2="12" y2="13" stroke="#333" strokeWidth="1" />
          <line x1="10" y1="11" x2="14" y2="11" stroke="#333" strokeWidth="1" />
        </svg>
      );
    case 'newgroup':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <circle cx="4" cy="5" r="1.5" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.4" />
          <circle cx="9" cy="5" r="1.5" fill="#FFD9A8" stroke="#8B4513" strokeWidth="0.4" />
          <path d="M1 13c0-1.5 1.5-3 3-3s3 1.5 3 3M6 13c0-1.5 1.5-3 3-3s3 1.5 3 3" fill="#D4A76A" stroke="#7A5020" strokeWidth="0.4" />
          <circle cx="12" cy="11" r="3" fill="#FFD700" stroke="#8B6914" strokeWidth="0.5" />
          <line x1="12" y1="9" x2="12" y2="13" stroke="#333" strokeWidth="1" />
          <line x1="10" y1="11" x2="14" y2="11" stroke="#333" strokeWidth="1" />
        </svg>
      );
    case 'newou':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <path d="M1 3h4l1.5 1.5H11v6H1z" fill="#FFC859" stroke="#8B6914" strokeWidth="0.5" />
          <circle cx="12" cy="11" r="3" fill="#FFD700" stroke="#8B6914" strokeWidth="0.5" />
          <line x1="12" y1="9" x2="12" y2="13" stroke="#333" strokeWidth="1" />
          <line x1="10" y1="11" x2="14" y2="11" stroke="#333" strokeWidth="1" />
        </svg>
      );
    case 'filter':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <path d="M2 3h12l-4 5v5l-4-2V8z" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.8" />
        </svg>
      );
    case 'help':
      return (
        <svg {...common} viewBox="0 0 16 16">
          <circle cx="8" cy="8" r="7" fill="#FFFF99" stroke="#8B6914" strokeWidth="0.8" />
          <text x="8" y="12" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#333">?</text>
        </svg>
      );
    default:
      return null;
  }
};
